import { defineMessages } from 'react-intl';

import type {
  ApiEstimationAdditionalFieldType,
  ApiEstimationStage,
  EstimationUnit,
} from '@/api/schema/data-contracts';

type EnumMessages<T extends string, P extends string> = Record<
  T,
  { id: `api.enum.${P}.${T}`; defaultMessage: string }
>;

export const apiEstimationStageMessageDefinitions = defineMessages<ApiEstimationStage>({
  IN_CREATION: {
    id: 'api.enum.ApiEstimationStage.IN_CREATION',
    defaultMessage: 'In Creation',
  },
  IN_PROCESS: {
    id: 'api.enum.ApiEstimationStage.IN_PROCESS',
    defaultMessage: 'In Process',
  },
  IN_REVIEW: {
    id: 'api.enum.ApiEstimationStage.IN_REVIEW',
    defaultMessage: 'In Review',
  },
  APPROVED: {
    id: 'api.enum.ApiEstimationStage.APPROVED',
    defaultMessage: 'Approved',
  },
} as EnumMessages<ApiEstimationStage, 'ApiEstimationStage'>);

export const apiEstimationAdditionalFieldTypeMessageDefinitions =
  defineMessages<ApiEstimationAdditionalFieldType>({
    TEXT: {
      id: 'api.enum.ApiEstimationAdditionalFieldType.TEXT',
      defaultMessage: 'Text',
    },
    FORMATTED_TEXT: {
      id: 'api.enum.ApiEstimationAdditionalFieldType.FORMATTED_TEXT',
      defaultMessage: 'Long text',
    },
    DURATION_TIME_SPAN: {
      id: 'api.enum.ApiEstimationAdditionalFieldType.DURATION_TIME_SPAN',
      defaultMessage: 'Duration',
    },
    SELECTABLE: {
      id: 'api.enum.ApiEstimationAdditionalFieldType.SELECTABLE',
      defaultMessage: 'Selectable',
    },
    DATE: {
      id: 'api.enum.ApiEstimationAdditionalFieldType.DATE',
      defaultMessage: 'Date',
    },
    DOCUMENT_LINK: {
      id: 'api.enum.ApiEstimationAdditionalFieldType.DOCUMENT_LINK',
      defaultMessage: 'Document Link / URL',
    },
  } as EnumMessages<ApiEstimationAdditionalFieldType, 'ApiEstimationAdditionalFieldType'>);

export const estimationUnitMessageDefinitions = defineMessages({
  PD: {
    id: 'api.enum.EstimationUnit.PD',
    defaultMessage: 'Person days',
  },
  HOURS: {
    id: 'api.enum.EstimationUnit.HOURS',
    defaultMessage: 'Hours',
  },
  STORY_POINTS: {
    id: 'api.enum.EstimationUnit.STORY_POINTS',
    defaultMessage: 'Story points',
  },
  CURRENCY: {
    id: 'api.enum.EstimationUnit.CURRENCY',
    defaultMessage: 'Currency',
  },
} as EnumMessages<EstimationUnit, 'EstimationUnit'>);
